import React from "react";
import { Navigate } from "@tanstack/react-router";

import HomepageContent from "components/homepage/HomepageContent";
import { toAndSearch } from "lib/spaNavigation";

export function HomepagePage() {
  const urlParams = new URLSearchParams(window.location.search);
  const currentView = urlParams.get("current_view_id");
  const showNoView = urlParams.get("showNoView");

  // Redirect to notices (aka old homepage) when query params specific to the old
  // homepage are present, preserving them so the notices page hydrates the view.
  if (currentView || showNoView) {
    return <Navigate {...toAndSearch(`/notices${window.location.search}`)} />;
  }

  return <HomepageContent />;
}
